import { ColumnDef } from '@tanstack/react-table';
import { Intake } from '@/entities/Courses';
import { IndeterminateCheckbox } from '@/shared/ui/IndeterminateCheckbox';
import { IntakeActions } from '../ui/components/IntakeActions';

interface IntakesColumnsProps {
  onToggleIntake?: (intakeId: number) => void;
  expandedIntakes?: Set<number>;
  onEditIntake?: (intakeId: number) => void;
  allowEditIntake?: boolean;
  allowHideIntake?: boolean;
  allowDeleteIntake?: boolean;
}

export const intakesColumns = ({
  onToggleIntake,
  expandedIntakes = new Set(),
  onEditIntake,
  allowEditIntake = true,
  allowHideIntake = true,
  allowDeleteIntake = true,
}: IntakesColumnsProps = {}): ColumnDef<Intake>[] => [
  {
    id: 'select',
    header: ({ table }) => (
      <IndeterminateCheckbox
        uniqueKey="all-intakes-select"
        name="all-intakes"
        checked={table.getIsAllRowsSelected()}
        indeterminate={table.getIsSomeRowsSelected()}
        onChange={table.getToggleAllRowsSelectedHandler()}
      />
    ),
    cell: ({ row }) => (
      <IndeterminateCheckbox
        uniqueKey={`intake-select-${row.original.id}`}
        name="intake"
        checked={row.getIsSelected()}
        disabled={!row.getCanSelect()}
        onChange={row.getToggleSelectedHandler()}
      />
    ),
  },
  {
    header: 'Title',
    accessorKey: 'title',
    cell: ({ row }) => {
      const expandable = Boolean(row.original.groups && row.original.groups.length > 0);
      return (
        <span
          className="text-black-headline"
          data-expand-title={expandable ? 'true' : undefined}
        >
          {row.original.title}
        </span>
      );
    },
  },
  {
    header: 'Enrolled',
    accessorKey: 'studentCount',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.studentCount}</span>
    ),
  },
  {
    header: 'Modules',
    accessorKey: 'modulesCount',
    cell: ({ row }) => (
      <span className="text-black-headline">{row.original.modulesCount}</span>
    ),
  },
  {
    header: 'Duration',
    accessorKey: 'totalLessonsDuration',
    cell: ({ row }) => {
      const hours = Math.floor(row.original.totalLessonsDuration / 60);
      const minutes = row.original.totalLessonsDuration % 60;
      return (
        <span className="text-black-headline">
          {hours > 0 ? `${hours}h ` : ''}
          {minutes > 0 ? `${minutes}m` : ''}
        </span>
      );
    },
  },
  {
    id: 'tools',
    cell: ({ row }) => (
      <IntakeActions
        intake={row.original}
        onToggle={() => onToggleIntake?.(row.original.id)}
        isExpanded={expandedIntakes.has(row.original.id)}
        hasGroups={row.original.groups && row.original.groups.length > 0}
        onEdit={onEditIntake}
        allowEdit={allowEditIntake}
        allowHide={allowHideIntake}
        allowDelete={allowDeleteIntake}
      />
    ),
  },
];

